import React from 'react';
import './NiraTestResultsDialog.css';

const NiraTestResultsDialog = ({ onClose, results, isLoading }) => {
    return (
        <div className="nira-test-dialog-overlay">
            <div className="nira-test-dialog">
                <div className="dialog-header">
                    <h2>NIRA Integration Test Results</h2>
                    <button className="close-btn" onClick={onClose} disabled={isLoading}>&times;</button>
                </div>

                <div className="dialog-body">
                    {isLoading ? (
                        <div className="loading-state">
                            <i className="fas fa-spinner fa-spin fa-2x"></i>
                            <p>Running tests across all NIRA endpoints...</p>
                        </div>
                    ) : (
                        <div className="results-list">
                            {results.map((result, index) => (
                                <div key={index} className={`result-item ${result.success ? 'success' : 'error'}`}>
                                    <div className="result-header">
                                        <h4>{result.endpointName}</h4>
                                        <span className="status-badge">
                      {result.success ? 'SUCCESS' : 'FAILED'}
                    </span>
                                    </div>
                                    <div className="result-content">
                                        {result.success ? (
                                            <pre>{JSON.stringify(result.data, null, 2)}</pre>
                                        ) : (
                                            <p className="error-message">{result.message}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="dialog-footer">
                    <button onClick={onClose} disabled={isLoading} className="btn btn-primary">
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NiraTestResultsDialog;